export enum REPLACE_MODE {
  MANUAL = 0,
  COMPLETE = 1,
}
